/**
 * 统一封装 localStorage / sessionStorage 读写，避免各处直接写 window.localStorage
 * 使用 constant/constant 中的 STORAGE_KEY 作为 key，便于维护与扩展
 */

const getStorage = (type: 'local' | 'session') => {
  if (typeof window === 'undefined') return null;
  return type === 'local' ? window.localStorage : window.sessionStorage;
};

/** 读 localStorage，key 建议用 STORAGE_KEY.xxx */
export function getLocal(key: string): string | null {
  const storage = getStorage('local');
  return storage ? storage.getItem(key) : null;
}

/** 写 localStorage */
export function setLocal(key: string, value: string): void {
  const storage = getStorage('local');
  if (storage) storage.setItem(key, value);
}

/** 删 localStorage */
export function removeLocal(key: string): void {
  const storage = getStorage('local');
  if (storage) storage.removeItem(key);
}

/** 读 sessionStorage */
export function getSession(key: string): string | null {
  const storage = getStorage('session');
  return storage ? storage.getItem(key) : null;
}

/** 写 sessionStorage */
export function setSession(key: string, value: string): void {
  const storage = getStorage('session');
  if (storage) storage.setItem(key, value);
}

/** 删 sessionStorage */
export function removeSession(key: string): void {
  const storage = getStorage('session');
  if (storage) storage.removeItem(key);
}
